<template>
  <div class="bg">
    <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        autocomplete="on"
        label-position="left"
    >
      <div class="title-container">
        <h3 class="title">知昇数据驾驶舱</h3>
      </div>

      <el-form-item prop="empEmail">
        <span class="svg-container">

        </span>
        <el-input
            class="user-input"
            ref="empEmail"
            v-model="loginForm.empEmail"
            placeholder="请输入邮箱"
            name="empEmail"
            type="text"
            tabindex="1"
            autocomplete="on"
        />
      </el-form-item>

      <el-tooltip
          v-model="capsTooltip"
          content="Caps lock is On"
          placement="right"
          manual
      >
        <el-form-item prop="empPwd">
          <span class="svg-container">

          </span>
          <el-input
              class="user-input"
              :key="passwordType"
              ref="empPwd"
              v-model="loginForm.empPwd"
              :type="passwordType"
              placeholder="请输入密码"
              name="empPwd"
              tabindex="2"
              autocomplete="on"
              @keyup.native="checkCapslock"
              @blur="capsTooltip = false"
          />
          <span class="show-pwd" @click="showPwd">

          </span>
        </el-form-item>
      </el-tooltip>
      <el-button
          :loading="loading"
          type="primary"
          style="width: 100%; margin-bottom: 60px"
          @click.native.prevent="handleLogin"
      >登录
      </el-button>
    </el-form>
  </div>
</template>

<script>
import {login} from '../api/user'
import Cookie from "js-cookie";

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      callback()
    }
    const validatePassword = (rule, value, callback) => {
      if (value == undefined || value.length < 1) {
        callback(new Error())
      } else {
        callback()
      }
    }

    const validateMobile = (rule, value, callback) => {
      callback()
    }
    // const validateNewPassword = (rule, value, callback) => {
    //   if (value == undefined || value.length < 6) {
    //     callback(new Error('请输入大于6位的新密码'))
    //   } else {
    //     callback()
    //   }
    // }

    const validateComPassword = (rule, value, callback) => {
      if (value == undefined || value.length < 1) {
        callback(new Error('请输入确认密码'))
      } else if (value != this.temp.empPwd) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    }

    const validateCode = (rule, value, callback) => {
      if (value == undefined || value.length < 1) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        empEmail: '',
        empPwd: ''
      },
      loginRules: {
        empEmail: [
          {
            required: true,
            trigger: 'blur',
            validator: validateUsername,
            message: '请输入正确的邮箱'
          }
        ],
        empPwd: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePassword,
            message: '请输入密码'
          }
        ]
      },

      forgerPasswordRules: {
        empEmail: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobile,
            message: '请输入正确的邮箱格式'
          }
        ],
        empPwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur'},
          {
            pattern: /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{8,16}$/,
            message: '至少含数字/字母/符号2种组合(不能使用中文、空格)'
          },
        ],

        confirmPwd: [
          {
            required: true,
            trigger: 'blur',
            validator: validateComPassword
          },
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur'},
          {
            pattern: /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{8,16}$/,
            message: '至少含数字/字母/符号2种组合(不能使用中文、空格)'
          },


        ],

        code: [
          {
            required: true,
            trigger: 'blur',
            validator: validateCode
            // message: "确认密码长度不能少于6位",
          }
        ]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      dialogFormVisible: false,
      buttonName: '获取验证码',
      isDisabled: false,
      bacCode: true,
      timer: null,
      temp: {
        empEmail: '',
        empPwd: '',
        confirmPwd: '',
        code: ''
      },

      pass_ttile: '忘记密码',
      resetTemp() {
        this.temp = {
          mobile: '',
          active: 0
        }
      }
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  mounted() {

  },

  methods: {
    checkCapslock(e) {
      const {key} = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      console.log(this.loginForm)
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          let res = await login(this.loginForm)
          console.log(res);
          if (res.data.code === 200) {
            let token = res.data.data;
            Cookie.set('AuthToken',token);
            this.$router.push('/dataScreenView')
          }

        } else {
          console.log('error submit!!')
          // return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
  }
}
</script>

<style scoped>
.bg{
  background-color: #333;
  width:100vw;
  height:100vh;
  position:absolute;
  left:0;
  top:0;
}
.login-form{
  width:500px;margin:10% auto;
}
.title-container{
  padding:20px;
  text-align: center;
  color:#fff;
}

</style>

